module.exports = __webpack_public_path__ + "img/step1.0eafe879.png";